import React from 'react';
import { Link } from 'wouter';
import { motion } from 'framer-motion';

export const HomeNavigationLogo: React.FC = () => {
  return (
    <Link href="/">
      <motion.div
        className="fixed top-4 left-4 z-50 cursor-pointer"
        whileHover={{ scale: 1.1, rotate: 180 }}
        whileTap={{ scale: 0.95 }}
        transition={{ duration: 0.3 }}
      >
        <div className="relative group">
          {/* Glow effect on hover */}
          <div className="absolute inset-0 bg-red-500 rounded-full blur-xl opacity-0 group-hover:opacity-50 transition-opacity duration-300" />
          
          {/* Logo container */}
          <div className="relative bg-black/50 backdrop-blur-lg rounded-full p-3 border border-white/20 group-hover:border-red-500/50 transition-colors duration-300">
            <img
              src="/propeller.png"
              alt="Home"
              className="w-10 h-10 object-contain filter brightness-0 invert opacity-90 group-hover:opacity-100 transition-opacity"
            />
          </div>
          
          {/* Tooltip */}
          <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 px-2 py-1 bg-black/80 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap">
            Return Home
          </div>
        </div>
      </motion.div>
    </Link>
  );
};

export default HomeNavigationLogo;